import { GetToken } from '../../config/Auth';

function useOrgao() {
    const token = GetToken();
    const {
        user: { orgaoUsuarioLogado },
    } = token ? JSON.parse(token) : { user: {} };
    return orgaoUsuarioLogado ?? {};
}

function useUsuarioLogado() {
    const token = GetToken();
    const { user } = token ? JSON.parse(token) : {};
    return user;
}

export { useOrgao, useUsuarioLogado };
